import * as actionTypes from 'actions';

const initialState = {
    Loading: false,
    workspaceCategoriesList: [],
    workspaceFormValues:[],
    workspaceCategoriesRecord:[],
    validation_error: "",
    redirect_to_list: false,
    showDeleteModel: false,
    showUpdateForm: false,
    showViewPage: false,
}

const WorkspaceCategoriesReducer = (state = initialState, action) => {
    switch (action.type) {
       
    case actionTypes.WORKSPACE_CATEGORIES_REQUEST:
        return {
          ...state,
          Loading: true,
          validation_error: "",
          redirect_to_list: false,
        }
    case actionTypes.WORKSPACE_CATEGORIES_SERVER_SUCCESS:
        return {
          ...state, 
          Loading: false,
          redirect_to_list: false,
          validation_error: "",
          showUpdateForm: false,
          showViewPage: false,
          workspaceCategoriesRecord: [],
        }    
    case actionTypes.WORKSPACE_CATEGORIES_SUCCESS:
        return {
          ...state, 
          Loading: false,
          redirect_to_list: false,
          validation_error: "",
          workspaceCategoriesList: action.workspaceCategoriesList,
          workspaceFormValues:action.workspaceFormValues,
          showUpdateForm: false,
          showViewPage: false,
          workspaceCategoriesRecord: [],
        }
    
    case actionTypes.WORKSPACE_CATEGORIES_GET_SUCCESS:
        return {
            ...state, 
            Loading: false,
            redirect_to_list: false,
            workspaceCategoriesRecord: action.record,
            showUpdateForm: (action.actionType === 'update')? true:false,
            showViewPage: (action.actionType === 'view')? true:false
        }    
    case actionTypes.WORKSPACE_CATEGORIES_VALIDATION_ERROR:
        return {
            ...state,
            Loading: false,
            redirect_to_list: false,
            validation_error: action.validation_error,
        } 
    case actionTypes.HIDE_WORKSPACE_CATEGORIES_FIELD_VALIDATION_ERROR:
        if(state.validation_error && state.validation_error[action.feild_key])
            delete state.validation_error[action.feild_key]
        return {
            ...state,
            Loading: false,
            redirect_to_list: false,
            validation_error: action.validation_error,
            
        } 
    case actionTypes.REDIRECT_TO_WORKSPACE_CATEGORIES_LIST:
        return {
            ...state,
            redirect_to_list: true,
            showUpdateForm: false,
            showViewPage: false,
            validation_error: '',
            workspaceCategoriesRecord: [],
        }
    default:
        return state;
    }
}

export default WorkspaceCategoriesReducer;